import { render } from "./WideBox.vue?vue&type=template&id=e8b74e2c&scoped=true"
import script from "./WideBox.vue?vue&type=script&lang=js"
export * from "./WideBox.vue?vue&type=script&lang=js"

import "./WideBox.vue?vue&type=style&index=0&id=e8b74e2c&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8b74e2c"]])

export default __exports__